import  { useContext } from "react";
import { LanguageContext } from "./../context/LanguageContextProvider";

export default function useLanguage() {
  const options = useContext(LanguageContext);
  return options;
}
